// Parent page

import { useParams } from 'react-router-dom';
import Layout from '../components/Layout';
import ParentCard from '../components/ParentCard';
import Spinner from '../components/Spinner';
import { useUser } from '../utils/hooks';
import { UsersRoles } from '../utils/enums';

export default function PageParent() {
  const { parentId } = useParams();
  const { entity: found, isResolved } = useUser(parentId);

  const parent = found?.role === UsersRoles.PARENT ? found : undefined;

  // Spinner only while the record could still show up — the current user's own
  // card is already in usersById, so it renders without waiting for the list
  if (!parent && !isResolved) {
    return (
      <Layout screenSized className='page-parent'>
        <Spinner show />
      </Layout>
    );
  }

  if (!parent) {
    return (
      <Layout screenSized className='page-parent'>
        <h1>{`Error: no route matches url "/parents/${parentId}"`}</h1>
      </Layout>
    );
  }

  return (
    <Layout className='page-parent' trail>
      <ParentCard parent={parent} />
    </Layout>
  );
}
